
export type MarkNotificationAsFailedBody = {
  reason: string;
};
